import { FilterGroup } from './category-filters';

export namespace CategoryFiltersParsers {
  export type FilterJson = {
    id: number;
    name: string;
    displayOrder: number;
    productCount?: number;
  };

  export type FilterGroupJson = {
    id: number;
    name: string;
    displayOrder: number;
    filters: FilterJson[];
  };

  export function toCategoryFilter(input: FilterGroupJson): FilterGroup {
    return {
      id: input.id,
      name: input.name,
      displayOrder: input.displayOrder,
      filters: input.filters.map((filter) => ({
        id: filter.id,
        name: filter.name,
        displayOrder: filter.displayOrder,
        productCount: filter.productCount,
      })),
    };
  }
}
